/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */

import openingHoursEmptyAdviseModalTemplate from './openingHoursEmptyAdviseModal.html';
import vasActivationModalTemplate from '../SavedWithSuccessModal.html';
import suggestToMakeMenuTemplate from '../SuggestToMakeMenuModal.html';


class orderAndPayController {

  /* @ngInject */

  constructor($log, $q, $timeout, MerchantConfigurationService,
              MerchantVasService, $scope, $rootScope,
              ModalFactory, TermsService, StorageService, NewTokenService,
              CatalogService) {

    const that = this;
    that.currentVasTypeId = MerchantVasService.getVasesTypes()['ORDER-AND-PICK'];
    that.currentWalletId = NewTokenService.getMerchantWalletID();
    that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    that.vasMenus = {};
    that.openingDays = [];

    this.showVasConfigurationMenuError = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: suggestToMakeMenuTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    this.showVasConfigurationSuccess = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: vasActivationModalTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    const openOpeningHoursEmptyAdviseModal = () => {

      const openingHoursEmptyAdviseModal = new ModalFactory({
        class: 'default',
        overlay: true,
        overlayClose: false,
        template: openingHoursEmptyAdviseModalTemplate,
        contentScope: {
          close: () => closeMerchantInfoModal()
        }
      });

      const closeMerchantInfoModal = () => {
        openingHoursEmptyAdviseModal.deactivate();
        $timeout(() => {
          openingHoursEmptyAdviseModal.destroy();
        }, 1000);
      };

      openingHoursEmptyAdviseModal.activate();

    };

    that.save = () => {
      let openingHours = that.getDays();

      if (openingHours.length !== 0 && (that.currentVas.configuration.schedulePickup || that.currentVas.configuration.pickupNow) ) {
        that.currentVas.configuration.openingHours = openingHours;
      } else if (openingHours.length === 0 && that.currentVas.configuration.schedulePickup) {
        openOpeningHoursEmptyAdviseModal();
        return;
      }

      MerchantVasService.configureVas(that.currentVas.configuration, that.currentVas.id).then((ok) => {
        that.currentVas.configuration = ok.data;
        that.showVasConfigurationSuccess();
      });
    };

    that.fillMenus = () => {

      CatalogService.getMenus().then((data) => {

        that.vasMenus = data;
        if (!that.vasMenus || that.vasMenus.length === 0) that.showVasConfigurationMenuError();

      });

    };

    this.hoursControlInited = () => {


    };

    const init = () => {

      that.fillMenus();
      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
        .then(
          (response) => {
            that.currentVas = response.data;
            that.setDays(that.currentVas.configuration.openingHours);
          },
          (error) => {
            alert('error retrieving the vas!');
          }
        );

    };


    that.$onInit = init;

  }

}

export default orderAndPayController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPick/orderAndPick.controller.js
 **/